import React from "react";
import { useNavigate } from "react-router-dom";

export default function PasswordResetModal() {
  const navi = useNavigate();

  const handleClick = () => {
    navi("/login");
  };
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
      <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Password Reset</p></div> 
      <p>Your password has been successfully reset. You can now log in using your new password.</p>

        <div className="send-modal-footer">
          <button className="pointer cancelButton fw-bold mx-2 px-3" onClick={handleClick}>
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
